module.exports = __webpack_public_path__ + "img/version_3.425d1d8e.png";